import { render, staticRenderFns } from "./btn-text-tertiary3.vue?vue&type=template&id=f6b5c2f0&scoped=true&"
import script from "./btn-text-tertiary3.vue?vue&type=script&lang=js&"
export * from "./btn-text-tertiary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5c2f0",
  null
  
)

export default component.exports